import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BrowserGeocoderPageRoutingModule } from './browser-geocoder-routing.module';

import { BrowserGeocoderPage } from './browser-geocoder.page';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ComponentsModule, BrowserGeocoderPageRoutingModule, TranslateModule.forChild()],
  declarations: [BrowserGeocoderPage]
})
export class BrowserGeocoderPageModule {}
